import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import { ValueToColor } from '@core/interfaces/bpc-display-config';

@Component({
  name: 'bpc-tabs',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class Tabs extends mixins(AbstractField) {
  @Prop([String, Number, Boolean]) readonly value: string | number | boolean;

  @Prop(Array) readonly options: object[];

  @Prop(Array) readonly valueToColor: ValueToColor[];

  @Prop([String, Number, Boolean]) readonly initialValue: string | number | boolean;

  @Prop({ type: Boolean, default: true }) readonly showAllTab: boolean;

  @Prop({ type: Boolean, default: false }) readonly showWithPills: boolean;

  get model(): string | number | boolean {
    return this.value;
  }
  set model(val: string | number | boolean) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  get selectClass(): string {
    const color = this.valueToColor?.find(item => item.value === this.model)?.color;
    return color ? `${color}` : '';
  }

  mounted() {
    this.model = null;
  }

  onClick($event) {
    if (this.showAllTab) {
      if ($event !== 0) {
        this.model = this.options[$event - 1]['value'];
        this.$emit('change', $event);
      } else {
        this.model = null;
      }
    } else {
      this.model = this.options[$event]['value'];
      this.$emit('change', $event);
    }
  }
}
